module.exports = __webpack_public_path__ + "static/media/lock.2f8dbb75.svg";